import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const GearboxType = ({ roles }) => {

    return (
        <M_Table entityName={'TransportGearboxType'} filtersOnTable rolePermissions={roles} />
    )
}